export type ValueOf<T> = T[keyof T];

export const RevenueSource = Object.freeze({
  Default: 0,
  Tariff: 1
});

export type RevenueSourceValues = ValueOf<typeof RevenueSource>;
export type RevenueSourceKeys = keyof typeof RevenueSource;